module.exports = __webpack_public_path__ + "img/image07.b99ae7ca.jpg";